/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { css, jsx, keyframes } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const pulseAnimation = keyframes({
	'0%': { opacity: 1 },
	'50%': { opacity: 0.4 },
	'100%': { opacity: 1 },
});

const containerStyles = css({
	padding: '8px 0',
});

const blockStyles = css({
	width: '100%',
	height: '160px',
	borderRadius: token('radius.small'),
	backgroundColor: token('color.skeleton'),
	animationName: pulseAnimation,
	animationDuration: '1.8s',
	animationTimingFunction: 'ease-in-out',
	animationIterationCount: 'infinite',
});

const textLineBaseStyles = css({
	height: '12px',
	borderRadius: token('radius.small'),
	backgroundColor: token('color.skeleton'),
	animationName: pulseAnimation,
	animationDuration: '1.8s',
	animationTimingFunction: 'ease-in-out',
	animationIterationCount: 'infinite',
});

const textLine1Styles = css({
	width: '90%',
	marginTop: token('space.150', '12px'),
});

const textLine2Styles = css({
	width: '70%',
	marginTop: token('space.100', '8px'),
});

const textLine3Styles = css({
	width: '40%',
	marginTop: token('space.100', '8px'),
});

export const SnippetLoadingPlaceholder = (): React.JSX.Element => (
	<div data-testid="snippet-loading-placeholder" css={containerStyles}>
		<div css={blockStyles} />
		<div css={[textLineBaseStyles, textLine1Styles]} />
		<div css={[textLineBaseStyles, textLine2Styles]} />
		<div css={[textLineBaseStyles, textLine3Styles]} />
	</div>
);
